import { render, staticRenderFns } from "./ExamMaterial.vue?vue&type=template&id=b245c920"
import script from "./ExamMaterial.vue?vue&type=script&lang=js"
export * from "./ExamMaterial.vue?vue&type=script&lang=js"
import style0 from "./ExamMaterial.vue?vue&type=style&index=0&id=b245c920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports